import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { perfilAcessoService } from '../../services/perfilAcesso';

interface SelectPerfilAcessoProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

const SelectPerfilAcesso: React.FC<SelectPerfilAcessoProps> = ({
  value,
  onChange,
  label = 'Perfil de Acesso',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
}) => {
  // Buscar todos os perfis de acesso
  const { data: perfis = [], isLoading } = useQuery({
    queryKey: ['perfisAcesso'],
    queryFn: () => perfilAcessoService.getAll(),
  });

  // Estado local para controlar o valor do Select
  const [localValue, setLocalValue] = React.useState('');

  // Sincronizar o valor quando os perfis carregarem
  React.useEffect(() => {
    if (!isLoading && perfis.length > 0) {
      const perfilExiste = perfis.some(perfil => perfil.id === value);
      if (perfilExiste) {
        setLocalValue(value);
      } else {
        setLocalValue('');
      }
    }
  }, [value, isLoading, perfis]);

  const handleChange = (event: any) => {
    onChange(event.target.value);
  };

  return (
    <FormControl 
      fullWidth={fullWidth} 
      required={required} 
      error={error}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>
      {isLoading ? (
        <Select
          value={''}
          onChange={handleChange}
          label={label}
        >
          <MenuItem disabled value={''}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <CircularProgress size={16} />
              Carregando...
            </Box>
          </MenuItem>
        </Select>
      ) : (
        <Select
          value={localValue}
          onChange={handleChange}
          label={label}
        >
          {perfis.length === 0 ? (
            <MenuItem disabled value={''}>
              Nenhum perfil cadastrado
            </MenuItem>
          ) : (
            perfis.map((perfil) => (
              <MenuItem key={perfil.id} value={perfil.id}>
                {perfil.name}
              </MenuItem>
            ))
          )}
        </Select>
      )}
      {helperText && (
        <Box sx={{ mt: 0.5, fontSize: '0.75rem', color: error ? 'error.main' : 'text.secondary' }}>
          {helperText}
        </Box>
      )}
    </FormControl>
  );
};

export default SelectPerfilAcesso;
